import { Form, Input, Button, Typography, Space, Divider, App, Switch } from 'antd';
import { PhoneOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import css from './Auth.module.css';

const { Title, Text } = Typography;

const OldRegister = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { oldRegister, loading } = useAuthStore();
  const { message } = App.useApp();

  const onFinish = async (values) => {
    console.log(values);

    const result = await oldRegister(values.fullname, values.phone, values.password, values.isvendor);
    if (result.success) {
      message.success("Muvaffaqiyatli ro'yxatdan o'tdingiz!");
      navigate('/');
    } else {
      message.error(result.message);
    }
  };

  return (
    <div>
      <Title level={3} style={{ marginBottom: 4 }}>
        Ro&apos;yxatdan o&apos;tish
      </Title>
      <Text type="secondary">Yangi hisob yarating</Text>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ marginTop: 24 }}
        size="large"
      >
        <Form.Item
          name="fullname"
          label="To'liq ism"
          rules={[
            { required: true, message: "Ismingizni kiriting" },
            { max: 255, message: "Ism juda uzun" },
            { min: 3, message: "Ism kamida 3 ta belgidan iborat bo'lishi kerak" },
          ]}
        >
          <Input prefix={<UserOutlined />} placeholder="Ism Familiya" size='large' />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Telefon raqam"
          rules={[
            { required: true, message: "Telefon raqamni kiriting" },
            {
              pattern: /^(\+998|0)\d{9}$/,
              message: "Format: +998901234567 yoki 0901234567",
            },
          ]}
        >
          <Input prefix={<><PhoneOutlined /></>} placeholder="+998901234567" size='large' />
        </Form.Item>

        <Form.Item
          name="password"
          label="Parol"
          rules={[
            { required: true, message: "Parolni kiriting" },
            { min: 6, message: "Parol kamida 6 ta belgidan iborat bo'lishi kerak" },
          ]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="Kamida 6 ta belgi" size='large' />
        </Form.Item>

        <Form.Item
          name="password_confirmation"
          label="Parolni tasdiqlash"
          dependencies={['password']}
          rules={[
            { required: true, message: "Parolni qayta kiriting" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Parollar mos kelmadi!'));
              },
            }),
          ]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="Parolni qayta kiriting" size='large' />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', flexDirection: 'column', backgroundColor: '#eaffeeff', padding: '10px', borderRadius: '10px', marginTop: '20px', border: '1px solid green' }}>
          <p>Agar Xizmat ko'rsatuvchi bo'lsangiz quyidagi joyni belgilang...</p>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <h3>Siz xizmat ko'rsatuvchimisiz?</h3>
            <Form.Item style={{ margin: '0' }} name={"isvendor"}>
              <Switch checkedChildren="XA" unCheckedChildren="YO'Q" size='large' />
            </Form.Item>
          </div>
        </div>



        <Form.Item style={{ marginBottom: 0, marginTop: '20px' }}>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Ro'yxatdan o'tish
          </Button>
        </Form.Item>
      </Form>

      <Divider style={{ margin: '20px 0' }} />

      <Space orientation="vertical" style={{ width: '100%' }} align="center" size={8}>
        <Text>
          Hisobingiz bormi? <Link to="/auth/login">Kiring</Link>
        </Text>
        <Text type="secondary">yoki</Text>
        <Link to="/auth/otp">
          <Button type="default" block>
            📱 OTP (Telegram) orqali kirish
          </Button>
        </Link>
      </Space>


     
    </div>
  );
};

export default OldRegister;
